var link_viewer_default = {
  "fontElementMap": "_6IxQB",
  "link": "deu2Z",
  "linkInEditor": "aw6xd",
  "linkInViewer": "W-gRs",
  "toolbarUrlContainer": "ApO9F",
  "toolbarUrl": "zgTkw",
  "toolbarUrlAnchor": "a26ra"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
